import { ToastPosition } from 'react-hot-toast'

const toast: ToastPosition = 'top-right'
const themeConfig = {
  app: {
    appName: 'PoolCom',
    appLogoShortImage: '/images/web/logo.png'
  },
  layout: {
    type: 'main',
    toastPosition: toast
  },
  system: {
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy HH:mm',
    timeFormat: 'HH:mm',
    dateFormatMoment: 'DD/MM/yyyy',
    dateTimeFormatMoment: 'HH:mm DD/MM/yyyy'
  },
  numberFormat: {
    decimalSeparator: ',',
    thousandSeparator: '.'
  }
}

export default themeConfig
